import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { uploadUrl } from "@/config/publicConfig";
import { useFetch } from "../../../../../hooks/useFetch";
import { Site, SiteById, Upload, UserCompact } from "../../../../../types/types";
import { Label } from "../../../../../ui/Label/Label";
import { SelectButton } from "../../../../../ui/SelectButton/SelectButton";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
// import DeleteUser from "../DeleteUser";
import { Input } from "../../../../../ui/Input/Input";
import { useAppStore } from "../../../../../stores/RootStore";
import { userStatuses } from "../../../../../enums";
import { useOutletContext } from "react-router-dom";
import { Avatar } from "@radix-ui/themes";

type Props = {
  id: string | undefined;
  currentSite: SiteById | undefined;
};

const OrgSettingsTab = ({ id, currentSite }: Props) => {
  //const [errors, setErrors] = useState([]);
  const [sites, setSites] = useOutletContext<[SiteById[], Function]>();
  const [imageId, setImageId] = useState(currentSite?.attributes.image?.id);

  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      name: currentSite?.attributes.name ? currentSite?.attributes.name : "",
      short_name: currentSite?.attributes.short_name ? currentSite?.attributes.short_name : "",
    },
  });

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  // Обновление информации об участнике
  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/users/sites/${id}`, true
  );

  // Загрузка изображения
  const [
    { response: imageUploadResponse, isLoading: imageUploadIsLoading, error: imageUploadError },
    doFetchImageUpload,
  ] = useFetch(`/uploads`, true, true);

  const onFileChoice = (value: string | Blob | File) => {
    const formData = new FormData();
    formData.set("attachment", value);
    doFetchImageUpload({
      method: "POST",
      data: formData,
    });
  };

  useEffect(() => {
    if (!imageUploadResponse) {
      return;
    }
    const imageUploadData = imageUploadResponse.data as unknown as Upload;
    setImageId(imageUploadData.id);
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          image: { ...imageUploadResponse.data },
        },
      },
    });
  }, [imageUploadResponse]);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
          short_name: formData.short_name,
        },
      },
    });
  };

  const editSite = (itemSaveResponse: { data: unknown }) => {
    const newSiteData = itemSaveResponse.data as unknown as SiteById;
    const withoutCurrentItem = sites?.filter((site) => site.id != currentSite?.id)!;
    setSites([...withoutCurrentItem, newSiteData]);
  };

  useEffect(() => {
    if (!saveResponse) return;
    editSite(saveResponse);
  }, [saveResponse]);

  return (
    <>
      <div className="pt-8">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <label>
              <Avatar
                size="7"
                src={imageId ? uploadUrl(imageId) : ""}
                fallback={
                  currentSite?.attributes.name
                    ? currentSite.attributes.name
                        .split(" ")
                        .map((word) => word[0])
                        .join("")
                    : "?"
                }
              />
              {/*@ts-ignore */}
              <input type="file" onChange={(evt) => onFileChoice(evt.target.files[0])} />
            </label>
            <div className="flex flex-col gap-3">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("title_name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="short_name"
                control={control}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("abbreviation")}`} />
                  </div>
                )}
              />

              <Separator />
              <div className="mt-8 flex w-full justify-between">
                {/* <Button variant={"destructive"} size={"sm"} type="button" onClick={() => openDeleteModal()}>
                  {t("delete")}
                </Button> */}
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      {/* <DeleteUser id={id!} isDeleteOpen={isDeleteOpen} closeModal={closeDeleteModal} /> */}
    </>
  );
};

export default OrgSettingsTab;
